import { ReactNode, CSSProperties } from 'react'

interface H4Props extends React.HTMLAttributes<HTMLHeadingElement> {
	cssVars?: Record<string, string>
	children: ReactNode
	className?: string
}

export const H4: React.FC<H4Props> = ({
	cssVars = {},
	children,
	className = '',
	style,
	...props
}) => {
	const inlineStyles: CSSProperties = {
		fontSize: cssVars['fontSize'] || undefined,
		fontWeight: cssVars['fontWeight'] || undefined,
		lineHeight: cssVars['lineHeight'] || undefined,
		fontFamily: cssVars['fontFamily'] || undefined,
		marginBottom: cssVars['marginBottom'] || undefined,
	}

	const mergedStyle = { ...inlineStyles, ...(style || {}) }
	const baseClasses = 'text-xl font-semibold leading-6 mb-1'
	const composedClassName = [baseClasses, className].filter(Boolean).join(' ')

	return (
		<h4 style={mergedStyle} className={composedClassName} {...props}>
			{children}
		</h4>
	)
}
